class PeopleSayingSlider extends HTMLElement {
  constructor () {
    super();
    this.swiper = null;
  }

  connectedCallback () {
    this.swiperEl = this;
    this.pagination = this.swiperEl.querySelector('.swiper-pagination');
    this.isLoopingEnabled = this.swiperEl.dataset.enableLooping === 'true';
    this.isAutoplayEnabled = this.swiperEl.dataset.enableAutoplay === 'true';
    this.disableOnInteraction = this.swiperEl.dataset.disableOnInteraction === 'true';
    this.autoplaySpeed = +this.swiperEl.dataset.autoplaySpeed;
    this.isPaginationEnabled = this.swiperEl.dataset.enablePagination === 'true';
    this.isPaginationClickable = this.swiperEl.dataset.paginationClickable === 'true';
    this.initSwiper();
  }

  initSwiper () {
    if (!this.swiperEl) return;

    const autoplay = this.isAutoplayEnabled ? {
      delay: this.autoplaySpeed * 1000,
      disableOnInteraction: this.disableOnInteraction,
    } : false;

    const pagination = this.isPaginationEnabled ? {
      el: this.pagination,
      clickable: this.isPaginationClickable
    } : false;

    this.swiper = new Swiper(this.swiperEl, {
      loop: this.isLoopingEnabled,
      autoplay,
      slidesPerView: 1.2,
      spaceBetween: 17,
      pagination,
      breakpoints: {
        575: {
          slidesPerView: 2.2
        },
        991: {
          slidesPerView: 2.5
        },
        1199: {
          slidesPerView: 4,
          spaceBetween: 20
        },
        1500: {
          slidesPerView: 5
        }
      },
    });
  }

  disconnectedCallback() {
    if (this.swiper && !this.swiper.destroyed) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('people-saying-slider')) {
  customElements.define('people-saying-slider', PeopleSayingSlider)
}